<template>
    <Dialog 
          :header="formMode == 'edit' ? 'Chỉnh sửa trường dữ liệu': 'Tạo mới trường dữ liệu'"
          :visible.sync="displayDialog"
          :contentStyle="{overflow: 'visible'}"
          :style="{width: '50vw'}"
          :class="'popup-dialog'"
          :modal="true"
        >
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Tên trường dữ liệu <span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <InputText id="name" type="text" v-model="name" :placeholder="'Nhập tên trường dữ liệu'"/>
                    <small v-if="validationErrors && validationErrors['name']"
                        class="p-invalid" >{{validationErrors['name']}}</small>
                    <small v-if="name_exists"
                    class="p-invalid" > Tên trường dữ liệu bị trùng </small>
                </div>
            </div>
            <div class="p-col-12 form-popup-custom">
               <div class="p-field">
                    <label>Control Type <span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <Dropdown   @change="changeTypeData($event, 'control_type')" v-model="control_type" :options="changeControlTypes" optionLabel="name" optionValue="value" placeholder="Chọn Control Type" :showClear="controlClear" />
                    <small v-if="validationErrors && validationErrors['control_type']"
                        class="p-invalid" >{{validationErrors['control_type']}}</small>
                </div>
            </div>

            <div class="p-col-12 form-popup-custom">
               <div class="p-field">
                    <label>Kiểu dữ liệu <span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <Dropdown   @change="changeTypeData($event, 'data_type')" v-model="data_type" :options="changeDataTypes" optionLabel="name" optionValue="value" placeholder="Chọn kiểu dữ liệu" :showClear="dataClear" />
                    <small v-if="validationErrors && validationErrors['data_type']"
                        class="p-invalid" >{{validationErrors['data_type']}}</small>
                </div>
            </div>
            <div class="p-col-12 form-popup-custom">
               <div class="p-field">
                    <label >Thứ tự hiển thị</label>
                    <div class="input-number-inline">
                        <InputNumber :min="-1"  id="ordering" v-model="ordering" showButtons />
                    </div>
               </div>
            </div>
            
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <div class="p-field-checkbox">
                        <Checkbox  v-model="is_required" :binary="true"/>
                        <label >Bắt buộc nhập</label>
                    </div>
                </div>
            </div>

            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <div class="p-field-checkbox">
                        <Checkbox  v-model="is_display" :binary="true"/>
                        <label >Hiển thị giao diện</label>
                    </div>
                </div>
            </div>
            
        </div>
        <template #footer>
            <Button :disabled="submitForm" class="p-button-success"  :label="formMode == 'edit' ? 'Lưu' : 'Tạo'" @click="saveData" />
        </template>
      </Dialog>
</template>

<script>
import DataServices from '@/core/DataServices'

export default {
  props: {
    show: Boolean,
    mode: String,
    modelName: String,
    model: Object,
    fieldsSample: Array
  },
  data() {
    return {
        name: '',
        changeControlTypes: [],
        control_type: '',
        controlTypes: [
            {name: 'Text Field', value: 'text', group: ['text']},
            {name: 'Text Area', value: 'textarea', group: ['text']},
            {name: 'Number Field', value: 'number', group: ['integer', 'float']},
            {name: 'Date Picker', value: 'date', group: ['date']}
        ],
        controlClear: false,
        changeDataTypes: [],
        data_type: '',
        dataTypes: [
            {name: 'String', value: 'text', group: ['text', 'textarea']},
            {name: 'Number', value: 'integer', group: ['number']},
            {name: 'Decimal', value: 'float', group: ['number']},
            {name: 'Date', value: 'date', group: ['date']}
        ],
        dataClear: false,
        is_display: true,
        is_required: false,
        ordering: 1,
        displayDialog: this.show,
        validationErrors: {},
        name_exists: false,
        field_sample: {},
        submitForm: false
    }
  },
  created() {
    this.formMode = this.mode;
    if (this.formMode === 'edit' && this.model !== undefined && this.model !== null && Object.entries(this.model).length) {
      this.name = this.model.name;
      this.is_display = this.model.is_display > 0;
      this.is_required = this.model.is_required > 0;
      this.ordering = this.model.ordering;
      this.control_type = this.model.fields.frontend_type;
      this.data_type = this.model.fields.backend_type;
    }
    this.changeControlTypes = this.controlTypes;
    this.changeDataTypes = this.dataTypes;
  },
  methods: {
    inputChange($event) {
        if (isNaN($event) || (!isNaN($event) && parseInt($event) < 1)) this.ordering = 1;
    },
    changeTypeData($event, $control) {
        var value = $event.value;
        if ($control == 'control_type') {
            if (value == null) {
                this.changeDataTypes = this.dataTypes;
                this.controlClear = false;
                this.control_type = '';
            }
            else {
                this.changeDataTypes = this.dataTypes.filter(a => a.group.includes(value));
                this.controlClear = true;
            }
        } else if ($control == 'data_type') {
            if (value == null) {
                this.changeControlTypes = this.controlTypes;
                this.dataClear = false;
                this.data_type = '';
            } else {
                this.changeControlTypes = this.controlTypes.filter(a => a.group.includes(value));
                this.dataClear = true;
            }
        }
    },
     async checkName() {
        this.name = this.name.trim();
        if (this.name !== undefined && this.name !== "") {
            var slug = this.$myConstants.cleanAccents(this.name, '-');
            var where = { fields: { _or: {name: {'_ilike': this.name}, alias: {'_eq':  slug} }} }
            if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
            var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
            return data && data[Object.keys(data)].length > 0
        }
    },
    async validateData() {
        this.validationErrors = {};
        if (this.name === undefined || this.name === "") this.validationErrors['name'] = 'Nhập tên trường dữ liệu';
        if (this.control_type == undefined || this.control_type == null|| this.control_type === "") this.validationErrors['control_type'] = 'Chọn Control Type';
        if (this.data_type == undefined || this.data_type == null || this.data_type === "") this.validationErrors['data_type'] = 'Chọn kiểu dữ liệu';
        this.name_exists = await this.checkName();
    },
    async saveData() {
        var formID = 1;
        this.submitForm = true;
        await this.validateData();
        var control = this.control_type;
        var fields = this.fieldsSample.filter(a => a.alias == control);
        if (fields != null && Object.keys(fields).length > 0) this.field_sample = fields[0];
        if (!this.name_exists && Object.entries(this.validationErrors).length === 0) {
            var params_field = {
                'form_id': formID,
                'ordering': this.ordering,
                'is_required': this.is_required ? 1 : 0,
                'is_display': this.is_display ? 1 : 0,
                'created_date': this.$myConstants.currentDate()
            };
            var params = {
                'name': this.name,
                'alias': this.$myConstants.cleanAccents(this.name, '-'),
                'backend_type': this.data_type,
                'frontend_type': this.control_type,
                'validation': this.field_sample.validation,
                'field_sample_id': this.field_sample.id
            }
            if (this.formMode === 'add') {
                params_field = Object.assign(params_field, { 'status': 1  });
                params = Object.assign(params, { 'form_field': {data: params_field  } });

                params = Object.assign(params, { 'status': 1 });
                params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() });
                await DataServices.insertData('fields', {"variables": JSON.stringify({objects: params})});
                this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
                this.displayDialog = false;
                this.$emit('refresh');
            } else {
                params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                await DataServices.updateData('fields', {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.model.field_id }}})});

                params_field = Object.assign(params_field, { 'modified_date': this.$myConstants.currentDate() })
                await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params_field, where_key: { id: {'_eq': this.model.id }}})});
                this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
                this.displayDialog = false;
                this.$emit('refresh');
            }
        } else this.submitForm = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>